import { useEffect, useState } from "react";
import { UI_CONFIG, API_BASE_URL } from "../constants/index";

export default function Congratulations({ prize, userEmail, emailSent, onContinue }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isClaiming, setIsClaiming] = useState(false);
  const [claimStatus, setClaimStatus] = useState(null);
  const [localEmailSent, setLocalEmailSent] = useState(emailSent);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    setLocalEmailSent(emailSent);
  }, [emailSent]);

  const handleContinue = async () => {
    setIsClaiming(true);
    setClaimStatus(null);
    
    try {
      // Get user data - use prop for email, localStorage for name
      const userName = localStorage.getItem("userFirstName");
      
      // console.log('🔍 Debug - User data:', { userEmail, userName });
      
      if (!userEmail || !userName) {
        // console.error('❌ Missing user data:', { userEmail, userName });
        setClaimStatus("error");
        return;
      }

      // console.log('📧 Sending email request to backend...');
      
      // Submit form to trigger email sending
      const response = await fetch(`${API_BASE_URL}/api/users/send-prize-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: userName,
          email: userEmail,
          prize: prize?.name || 'Prix gagné',
        }),
      });

      // console.log('📡 Response status:', response.status);
      //console.log('📡 Response ok:', response.ok);

      if (response.ok) {
        const responseData = await response.json();
        // console.log('✅ Success response:', responseData);
        setClaimStatus("success");
        setLocalEmailSent(true); // Mark email as sent locally
      } else {
        const errorData = await response.text();
        // console.error('❌ Error response:', errorData);
        setClaimStatus("error");
      }
    } catch (error) {
      // console.error('💥 Fetch error:', error);
      setClaimStatus("error");
    } finally {
      setIsClaiming(false);
    }
  };





  return (
    <div className="w-full h-screen bg-gradient-to-b from-orange-500 via-orange-600 to-yellow-600 flex flex-col justify-center items-center px-4">
      {/* Logo */}
      <div className="mb-6">
        <img 
          src="/static/juniorisep.svg" 
          alt="JUNIORISEP Logo" 
          className="w-16 h-16 object-contain filter brightness-0 invert"
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 text-center">
        Félicitations !
      </h1>

      {/* Prize Display */}
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm mx-auto mb-6 text-center shadow-lg">
        <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        </div>
        
        <h2 className="text-xl font-bold text-gray-800 mb-3">
          {prize?.name || 'Prix Gagné'}
        </h2>

        <p className="text-gray-600 text-sm mb-4">
          Récupère ton prix lors de notre <strong>after work</strong> le 10 septembre. Plus de détails sur Instagram <a href="https://www.instagram.com/juniorisep/" target="_blank" rel="noopener noreferrer" className="text-orange-600 underline font-semibold">@juniorisep</a>.
        </p>

        <button
          onClick={handleContinue}
          disabled={isClaiming || localEmailSent}
          className="w-full bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {localEmailSent ? 'Email déjà envoyé' : (isClaiming ? 'Envoi en cours...' : 'Récupère ton prix')}
        </button>

        {isClaiming && (
          <div className="mt-3 bg-blue-50 border border-blue-200 rounded-lg p-2 text-center">
            <p className="text-blue-800 text-xs font-medium">
              📧 Envoi de l'email en cours...
            </p>
          </div>
        )}

        {claimStatus === 'success' && (
          <div className="mt-3 bg-green-50 border border-green-200 rounded-lg p-2 text-center">
            <p className="text-green-800 text-xs font-medium">
              ✅ Email envoyé avec succès ! Vérifiez votre boîte de réception.
            </p>
          </div>
        )}

        {claimStatus === 'error' && (
          <div className="mt-3 bg-red-50 border border-red-200 rounded-lg p-2 text-center">
            <p className="text-red-800 text-xs font-medium">
              ❌ Erreur lors de l'envoi de l'email
            </p>
          </div>
        )}
      </div>

      {/* Branding */}
      <p className="text-white/80 text-xs text-center">
        Créé par <span className="font-semibold">Junior ISEP</span>
      </p>
    </div>
  );
}
